import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectInvitationsList } from 'features/bpList/ducks/selectors'
import { getInvitationsListForBpRoutine } from 'features/accessControl/ducks/actions'
import { fetchUnitInvitationsListRoutine } from 'ducks/units/actions'
import { selectUnitInvitationsList } from 'ducks/units/selectors'
import { isNotNilOrEmpty } from 'utils/ramda'
import { getSelectedBp } from 'features/bpDetails/ducks/selectors'
import { filterOutStaff } from 'utils/user'
import InvitationsSection from './InvitationBox'

const InvitationsList = ({ unit, canAccept, canManage, items, onCancel, onChanged, onCountChange = () => {}, scopeType, scopeId }) => {
  const bp = useSelector(getSelectedBp)
  const bpInvitations = useSelector(selectInvitationsList)
  const unitInvitations = useSelector(selectUnitInvitationsList)
  const dispatch = useDispatch()

  const selectorInvitations = useMemo(() => {
    return isNotNilOrEmpty(unit) ? unitInvitations : bpInvitations
  }, [bpInvitations, unitInvitations, unit])

  const invitations = useMemo(
    () => filterOutStaff(items != null ? items : (selectorInvitations || [])) || [],
    [items, selectorInvitations]
  )

  useEffect(() => {
    if (items != null) return
    if (unit) {
      dispatch(fetchUnitInvitationsListRoutine({ bpId: bp.id, unitId: unit.id }))
    } else if (bp) {
      dispatch(getInvitationsListForBpRoutine(bp.id))
    }
  }, [unit, bp, dispatch, items])

  useEffect(() => {
    onCountChange(Array.isArray(invitations) ? invitations.length : 0)
  }, [invitations, onCountChange])

  return (
    <InvitationsSection
      invitations={invitations || []}
      unit={unit}
      canAccept={canManage != null ? canManage : canAccept}
      onCancel={onCancel}
      onChanged={onChanged}
      onCountChange={onCountChange}
      scopeType={scopeType}
      scopeId={scopeId}
    />
  )
}

export default InvitationsList
